import { render, staticRenderFns } from "./KnowledgeBaseView.vue?vue&type=template&id=abfb2ad6&scoped=true&"
import script from "./KnowledgeBaseView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfb2ad6",
  null
  
)

export default component.exports